export const eventTypes = {
  PURCHASE: 'purchase',
  VISIT: 'visit',
  BUY_NOW: 'buy-now',
};
